/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetProfileDto } from './GetProfileDto';
import {
    GetProfileDtoFromJSON,
    GetProfileDtoFromJSONTyped,
    GetProfileDtoToJSON,
} from './GetProfileDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';

/**
 * 
 * @export
 * @interface GetSalesInvoicingDto
 */
export interface GetSalesInvoicingDto {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoicingDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    status: GetSalesInvoicingDtoStatusEnum;
    /**
     * 
     * @type {GetProfileDto}
     * @memberof GetSalesInvoicingDto
     */
    profile: GetProfileDto;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetSalesInvoicingDto
     */
    project: GetProjectDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicingDto
     */
    isSalesBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicingDto
     */
    isPurchaseBlocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicingDto
     */
    active: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoicingDto
     */
    statusTs: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    commentsMediaplanner: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    commentsFinance: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    lastCommentMediaplanner: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    lastCommentFinance: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    salesTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoicingDto
     */
    amountToInvoice: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicingDto
     */
    confirmInDocs: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoicingDto
     */
    statusTsForReady?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoicingDto
     */
    hasCorrection?: boolean;
}


/**
 * @export
 */
export const GetSalesInvoicingDtoStatusEnum = {
    New: 'New',
    AcceptedByClient: 'AcceptedByClient',
    ReadyForInvoice: 'ReadyForInvoice',
    Invoiced: 'Invoiced',
    Corrected: 'Corrected',
    Settled: 'Settled',
    Cancelled: 'Cancelled',
    Withdrawn: 'Withdrawn'
} as const;
export type GetSalesInvoicingDtoStatusEnum = typeof GetSalesInvoicingDtoStatusEnum[keyof typeof GetSalesInvoicingDtoStatusEnum];


/**
 * Check if a given object implements the GetSalesInvoicingDto interface.
 */
export function instanceOfGetSalesInvoicingDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "profile" in value;
    isInstance = isInstance && "project" in value;
    isInstance = isInstance && "isSalesBlocked" in value;
    isInstance = isInstance && "isPurchaseBlocked" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "statusTs" in value;
    isInstance = isInstance && "commentsMediaplanner" in value;
    isInstance = isInstance && "commentsFinance" in value;
    isInstance = isInstance && "lastCommentMediaplanner" in value;
    isInstance = isInstance && "lastCommentFinance" in value;
    isInstance = isInstance && "salesTotal" in value;
    isInstance = isInstance && "amountToInvoice" in value;
    isInstance = isInstance && "confirmInDocs" in value;

    return isInstance;
}

export function GetSalesInvoicingDtoFromJSON(json: any): GetSalesInvoicingDto {
    return GetSalesInvoicingDtoFromJSONTyped(json, false);
}

export function GetSalesInvoicingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoicingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'status': json['status'],
        'profile': GetProfileDtoFromJSON(json['profile']),
        'project': GetProjectDtoFromJSON(json['project']),
        'isSalesBlocked': json['isSalesBlocked'],
        'isPurchaseBlocked': json['isPurchaseBlocked'],
        'active': json['active'],
        'statusTs': (new Date(json['statusTs'])),
        'commentsMediaplanner': json['commentsMediaplanner'],
        'commentsFinance': json['commentsFinance'],
        'lastCommentMediaplanner': json['lastCommentMediaplanner'],
        'lastCommentFinance': json['lastCommentFinance'],
        'salesTotal': json['salesTotal'],
        'amountToInvoice': json['amountToInvoice'],
        'confirmInDocs': json['confirmInDocs'],
        'statusTsForReady': !exists(json, 'statusTsForReady') ? undefined : (json['statusTsForReady'] === null ? null : new Date(json['statusTsForReady'])),
        'hasCorrection': !exists(json, 'hasCorrection') ? undefined : json['hasCorrection'],
    };
}

export function GetSalesInvoicingDtoToJSON(value?: GetSalesInvoicingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date.toISOString()),
        'status': value.status,
        'profile': GetProfileDtoToJSON(value.profile),
        'project': GetProjectDtoToJSON(value.project),
        'isSalesBlocked': value.isSalesBlocked,
        'isPurchaseBlocked': value.isPurchaseBlocked,
        'active': value.active,
        'statusTs': (value.statusTs.toISOString()),
        'commentsMediaplanner': value.commentsMediaplanner,
        'commentsFinance': value.commentsFinance,
        'lastCommentMediaplanner': value.lastCommentMediaplanner,
        'lastCommentFinance': value.lastCommentFinance,
        'salesTotal': value.salesTotal,
        'amountToInvoice': value.amountToInvoice,
        'confirmInDocs': value.confirmInDocs,
        'statusTsForReady': value.statusTsForReady === undefined ? undefined : (value.statusTsForReady === null ? null : value.statusTsForReady.toISOString()),
        'hasCorrection': value.hasCorrection,
    };
}

